import { Row, RenderConfig, TextInput, SelectInput, BOOLEAN_OPTIONS, EMPTY_STRING } from 'commons-ui';
import { SEGMENT_ABTEST_NAME_VALIDATON_MESSAGE, SEGMENT_ABTEST_NAME_PLACEHOLDER_MESSAGE } from 'constant';
import { FormDefaults } from './utils/types';

export const FORM_FIELD_KEYS = {
	FEATURE_ID: 'featureId',
	SEGMENT_NAME: 'segmentName',
	ENABLED: 'enabled'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.FEATURE_ID]: 'Feature Id',
	[FORM_FIELD_KEYS.SEGMENT_NAME]: 'Segment Name',
	[FORM_FIELD_KEYS.ENABLED]: 'Enabled'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.FEATURE_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.FEATURE_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.FEATURE_ID])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.SEGMENT_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.SEGMENT_NAME])
		.setRenderer(TextInput)
		.setDescription(SEGMENT_ABTEST_NAME_VALIDATON_MESSAGE)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			placeholder: SEGMENT_ABTEST_NAME_PLACEHOLDER_MESSAGE
		}),
	[FORM_FIELD_KEYS.ENABLED]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ENABLED)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ENABLED])
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		})
};

export const EDIT_FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.FEATURE_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.FEATURE_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.FEATURE_ID])
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false }, required: true }),
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.SEGMENT_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.SEGMENT_NAME])
		.setRenderer(TextInput)
		.setDescription(SEGMENT_ABTEST_NAME_VALIDATON_MESSAGE)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true,
			placeholder: SEGMENT_ABTEST_NAME_PLACEHOLDER_MESSAGE
		}),
	[FORM_FIELD_KEYS.ENABLED]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ENABLED)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ENABLED])
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: false, edit: true }, options: BOOLEAN_OPTIONS, required: true })
};

export const getFormDefaults = (): FormDefaults => {
	return {
		featureId: EMPTY_STRING,
		segmentName: EMPTY_STRING,
		enabled: true
	};
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.FEATURE_ID),
	new Row(FORM_FIELD_KEYS.SEGMENT_NAME),
	new Row(FORM_FIELD_KEYS.ENABLED)
];
